import type { StatusBadgeTone } from '@shared/ui';

const COURSE_STATUS_TONES = new Map<string, StatusBadgeTone>([
  ['course active', 'informational'],
  ['course archived', 'neutral'],
  ['course completed', 'positive'],
  ['enrollment closed', 'informational'],
  ['enrollment open', 'positive'],
]);

const RESULT_TONES = new Map<string, StatusBadgeTone>([
  ['passed', 'positive'],
  ['not passed', 'negative'],
]);

function normalizeStatus(status: string): string {
  return status.trim().toLocaleLowerCase('en-US');
}

export function getCourseStatusTone(status: string): StatusBadgeTone {
  return COURSE_STATUS_TONES.get(normalizeStatus(status)) ?? 'neutral';
}

export function getResultTone(result: string): StatusBadgeTone {
  return RESULT_TONES.get(normalizeStatus(result)) ?? 'neutral';
}

// Presentation only: options and submitted values remain owned by the API catalogues.
const LEARNING_LABEL_KEYS: Record<string, Readonly<Record<string, string>>> = {
  course: {
    'course active': 'crm.customerLearning.statuses.courseActive',
    'course archived': 'crm.customerLearning.statuses.courseArchived',
    'course completed': 'crm.customerLearning.statuses.courseCompleted',
    'enrollment closed': 'crm.customerLearning.statuses.enrollmentClosed',
    'enrollment open': 'crm.customerLearning.statuses.enrollmentOpen',
  },
  registration: {
    paid: 'crm.learningProfiles.statuses.paid',
    unpaid: 'crm.customerMembership.statuses.unpaid',
    refunded: 'crm.customerLearning.statuses.refunded',
    'no cost': 'crm.customerLearning.statuses.noCost',
    'materials are available': 'crm.customerLearning.statuses.materialsAvailable',
    'materials are not available': 'crm.customerLearning.statuses.materialsUnavailable',
  },
  result: {
    passed: 'crm.learningProfiles.statuses.passed',
    'not passed': 'crm.learningProfiles.statuses.notPassed',
  },
};

export function getLearningValueLabel(
  kind: 'course' | 'registration' | 'result',
  value: string,
  translate: (key: string, fallback: string) => string,
  display = value
): string {
  const key = LEARNING_LABEL_KEYS[kind][normalizeStatus(value)];
  return key ? translate(key, display) : display;
}
